import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Guards a page behind a configurable module. A direct URL to a hidden module
// redirects to the dashboard (the API is guarded too — this just avoids a flash
// and a 403 round-trip). owner/td always pass via canView.
export const ModuleRoute = ({ module, children }) => {
  const { loading, canView } = useAuth();
  if (loading) return null;
  if (!canView(module)) return <Navigate to="/dashboard" replace />;
  return children;
};
